// extracted by mini-css-extract-plugin
export default {"policy-details":"styles_policy-details__rMWOO"};